import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import {
  storageLocationIdFormat,
  taskIdFormat,
  transferSessionIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const ReplenishmentQueueTaskSchema = z.object({
  taskId: taskIdFormat.schema.nullable(),
  status: z.enum(["queued", "in_progress"]),
  phase: z.enum(["source", "distribute"]).nullable(),
  name: z.string().nullable(),
  productId: productIdFormat.schema.nullable(),
  sku: z.string().nullable(),
  productTitle: z.string().nullable(),
  storageLocationId: storageLocationIdFormat.schema.nullable(),
  binName: z.string().nullable(),
  claimedAt: z.date().nullable(),
});
export type ReplenishmentQueueTask = z.infer<
  typeof ReplenishmentQueueTaskSchema
>;

export const getReplenishmentQueue = {
  name: "getReplenishmentQueue" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({ tasks: z.array(ReplenishmentQueueTaskSchema) }),
};

export const startNextReplenishmentTask = {
  name: "startNextReplenishmentTask" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({
    transferSessionId: transferSessionIdFormat.schema.nullable(),
    remaining: z.number().int().nonnegative(),
  }),
};
